<template>
    <div>
        <div v-if="editEnabled" class="cms-course-wrapper-2" v-for="component in page.components"
             draggable
             @dragstart="$emit('handleDrag',$event, component)"
             @drop="$emit('handleDrop', $event, component)"
             @dragover.prevent
             @dragenter.prevent>

            <div class="d-flex justify-content-end">
                <i class="fa fa-2x fa-bars mr-3 mt-1 text-white"></i>
            </div>
            <div class="container-fluid mb-2">
                <label>Type</label>
                <select v-model="component.type" @change="$emit('handleTypeChange', component)">
                    <option value="text">Text</option>
                    <option value="html">HTML</option>
                    <option value="image">Image</option>
                    <option value="video">Video</option>
                    <option value="question">Question</option>
                    <option value="pdf">PDF</option>
                    <option value="scorm">SCORM</option>
                </select>
            </div>

            <div class="container-fluid" v-if="component.type == 'html'">
                <label>HTML</label>
                <textarea v-model="component.html" type="text" rows="20"></textarea>
            </div>

            <div class="container-fluid" v-if="component.type == 'image'">
                <div>
                    <label>Name</label>
                    <input v-model="component.name" type="text" />
                </div>
                <div>
                    <label>Description</label>
                    <input v-model="component.description" type="text" />
                </div>
                <div>
                    <label>Alignment</label>
                    <input type="number" v-model.number="component.alignmentX" placeholder="X Alignment" />
                    <input type="number" v-model.number="component.alignmentY" placeholder="Y Alignment" />
                </div>
                <div>
                    <label>File</label>
                    <input @change="$emit('fileChange', $event.target, component, '')" type="file" />
                    <img v-bind:src="component | s3url('')" />
                </div>
            </div>

            <div class="container-fluid" v-if="component.type == 'pdf'">
                <div>
                    <label>Name</label>
                    <input v-model="component.name" type="text" />
                </div>
                <div>
                    <label>File Name</label>
                    <input v-model="component.fileName" type="text" disabled />
                </div>
                <div>
                    <label>File</label>
                    <input @change="$emit('fileChange', $event.target, component, '')" type="file" />
                </div>
            </div>

            <div class="container-fluid" v-if="component.type == 'scorm'">
                <div>
                    <label>Name</label>
                    <input v-model="component.name" type="text" />
                </div>
                <div>
                    <label>File Name</label>
                    <input v-model="component.fileName" type="text" disabled />
                </div>
                <div>
                    <label>File</label>
                    <input @change="$emit('fileChange', $event.target, component, '')" type="file" />
                </div>
            </div>

            <div v-if="component.type == 'text'">
                <rich-text-component v-on:htmlChanged="handleHtmlChanged" :initialComponent="component" />
            </div>

            <div class="container-fluid" v-if="component.type == 'video'">
                <div>
                    <label>Name</label>
                    <input v-model="component.name" type="text" />
                </div>
                <div>
                    <label>Description</label>
                    <input v-model="component.description" type="text" />
                </div>
                <div>
                    <label>Alignment</label>
                    <input type="number" v-model.number="component.alignmentX" placeholder="X Alignment" />
                    <input type="number" v-model.number="component.alignmentY" placeholder="Y Alignment" />
                </div>
                <div>
                    <label>File</label>
                    <input @change="$emit('fileChange', $event.target, component, '')" type="file" />
                    <video style="max-width: 100%" controls v-bind:src="component | s3url('')" />
                </div>
            </div>

            <div class="container-fluid" v-if="component.type == 'question'" style="border-bottom: 1px solid white;">
                <label>Question</label>
                <input v-model="component.questionText" type="text" />

                <label>Solution explanation</label>
                <input v-model="component.solutionText" type="text" />

                <table class="table text-white">
                    <thead>
                        <tr>
                            <th>
                                Answer
                            </th>
                            <th class="text-center">
                                Is Correct Answer
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="answer in component.answers">
                            <td>
                                <input v-model="answer.answerText" type="text" />
                            </td>
                            <td class="d-flex justify-content-center">
                                <input v-model="answer.isCorrect" type="checkbox" />
                            </td>
                            <td class="pr-0">
                                <div class="container-fluid d-flex justify-content-end pr-0">
                                    <button type="button" class="btn btn-delete-alt mt-1" v-on:click="$emit('handleDelete', component, answer)">Delete</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-center">
                    <button type="button" class="btn btn-add text-white" v-on:click="$emit('handleAddAnswer', component)">Add answer</button>
                </div>
            </div>
            <div class="cms-btn-wrapper pb-0 d-flex justify-content-end pr-3">
                <button type="button" class="btn btn-delete" v-on:click="$emit('handleDelete', page, component)">
                    <i class="fa fa-2x fa-trash"></i>
                </button>
                <button type="button" class="btn btn-add text-white" style="margin-left: 10px;" v-on:click="$emit('handleMoveItem', page, component, true)">
                    <i class="fa fa-2x fa-arrow-up"></i>
                </button>
                <button type="button" class="btn btn-add text-white" style="margin-left: 10px;" v-on:click="$emit('handleMoveItem', page, component, false)">
                    <i class="fa fa-2x fa-arrow-down"></i>
                </button>
            </div>
        </div>
        <!--preview page and components-->
        <div v-else>
            <!--draggable if not editing?-->
            <div class="cms-course-wrapper-preview pb-2"
                 draggable
                 @dragstart="$emit('handleDrag',$event, component)"
                 @drop="$emit('handleDrop', $event, component)"
                 @dragover.prevent
                 @dragenter.prevent>

                <div v-if="component.type == 'html'">
                    <p v-html="component.html"></p>
                </div>

                <div v-if="component.type == 'image'">
                    <div>
                        <label>Name</label>
                        <h4>{{component.name}}</h4>
                    </div>
                    <div>
                        <label>File</label>
                        <img v-bind:src="component | s3url('')" />
                    </div>
                </div>

                <div v-if="component.type == 'pdf'">
                    <div>
                        <label>Name</label>
                        <h4>{{component.name}}</h4>
                    </div>
                    <div>
                        <label>File Name</label>
                        <h4>{{component.fileName}}</h4>
                    </div>
                </div>

                <div v-if="component.type == 'scorm'">
                    <div>
                        <label>Name</label>
                        <h4>{{component.name}}</h4>
                    </div>
                    <div>
                        <label>File Name</label>
                        <h4>{{component.fileName}}</h4>
                    </div>
                </div>

                <div v-if="component.type == 'text'" class="tx-comp">
                    <div>
                        <p v-show="!component.html">Nothing yet!</p>
                        <p v-html="component.html"></p>
                    </div>
                </div>

                <div v-if="component.type == 'video'">
                    <div>
                        <label>Video</label>
                    </div>
                    <div>
                        <div class="video-wrapper overflow-hidden" style="height: 100px;">
                            <video v-bind:src="component | s3url('')" style="height: 100%;"/>
                        </div>
                    </div>
                </div>

                <div v-if="component.type == 'question'">
                    <label>Question</label>
                    <div  v-html="component.questionText"></div>

                    <br />
                    <label>Solution</label>
                    <div v-html="component.solutionText"></div>
                    <br />

                    <table class="table">
                        <thead>
                            <tr>
                                <th>
                                    Answer
                                </th>
                                <th>
                                    Is Correct Answer
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="answer in component.answers">
                                <td>
                                    <span>{{answer.answerText}}</span>
                                </td>
                                <td>
                                    <span>{{answer.isCorrect ? "True" : "False"}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="page.components.length < 1" class="title">
                    No components yet! <br />Enable edit mode to add new components
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ComponentList",
        props: ["initialPage", "edit"],
        data() {
            return {
                page: this.initialPage,
                editEnabled: this.edit,
            }
        },
        methods: {
            handleHtmlChanged(value, id) {
                this.$emit('handleUpdateHtml', value, id);
            },
        },
        watch: {
            initialPage: function (newVal, oldVal) {
                this.page = newVal;
            },
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            }
        },
        mounted() {
            //console.log("Page component loaded", this.initialPage.name, this.edit);
        }
    }
</script>